var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5303 1.46967C22.8232 1.76256 22.8232 2.23744 22.5303 2.53033L12.5303 12.5303C12.2374 12.8232 11.7626 12.8232 11.4697 12.5303C11.1768 12.2374 11.1768 11.7626 11.4697 11.4697L21.4697 1.46967C21.7626 1.17678 22.2374 1.17678 22.5303 1.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 10.0534 21.4438 8.23678 20.4817 6.70026L18.8362 8.34582C18.829 8.33249 18.8218 8.31918 18.8146 8.30589C19.4112 9.40401 19.75 10.6624 19.75 12C19.75 16.2802 16.2802 19.75 12 19.75C7.71979 19.75 4.25 16.2802 4.25 12C4.25 7.71979 7.71979 4.25 12 4.25C13.3214 4.25 14.5655 4.5807 15.6542 5.16385L17.2997 3.51828C15.7632 2.55617 13.9466 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 12C5.75 8.54822 8.54822 5.75 12 5.75C12.9018 5.75 13.759 5.94099 14.5333 6.28472L13.3681 7.44997C12.9348 7.31989 12.4756 7.25 12 7.25C9.37665 7.25 7.25 9.37665 7.25 12C7.25 14.6234 9.37665 16.75 12 16.75C14.6234 16.75 16.75 14.6234 16.75 12C16.75 11.5244 16.6801 11.0652 16.55 10.6319L17.7153 9.4667C18.059 10.241 18.25 11.0982 18.25 12C18.25 15.4518 15.4518 18.25 12 18.25C8.54822 18.25 5.75 15.4518 5.75 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 11.9775 15.2498 11.9551 15.2493 11.9327L13.591 13.591C12.7123 14.4697 11.2877 14.4697 10.409 13.591C9.53033 12.7123 9.53033 11.2877 10.409 10.409L12.0673 8.75068C12.0449 8.75023 12.0225 8.75 12 8.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetAlt3);
export default __webpack_public_path__ + "static/media/target-alt-3.3600cbd30fcfed56dda8d888276ef6e7.svg";
export { ForwardRef as ReactComponent };